import styled from 'styled-components'
import {
  Panel,
  PanelSection,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from './Panel'

export default Object.assign(Panel, {
  Section: PanelSection,
  Title: PanelHeader,
  Header: PanelHeader,
  Body: styled(PanelBody)``,
  Footer: PanelFooter,
})
